import React from 'react'
import { ConfirmationMessageContainer, Heading4 } from '../style/ConfirmationWmo.css'

const ConfirmationMessageWmo = ({ item }) => {
  const { customerEmailAddress } = { ...item }

  return (
    <ConfirmationMessageContainer>
      <Heading4>You&apos;re almost done!</Heading4>
      <p>
        A copy of your request has been emailed to
        &nbsp;
        <span>{customerEmailAddress}</span>
        . We&apos;ll inspect your parts upon receipt and issue a refund based
        on your original purchase cost.
      </p>
    </ConfirmationMessageContainer>
  )
}

export default ConfirmationMessageWmo
